/**
 * goal-pages.js
 * Client-side interactivity for Shop-by-Goal destination pages.
 *
 * Currently handles:
 *   - Grading filter on the High-End Display page
 *     Buttons: [data-company="all|PSA|BGS|CGC"]
 *     Products: .gp-product-wrapper[data-grading-company="PSA|BGS|CGC"]
 *     Active class on button: gp-grade-filter-btn--active
 *     Hidden class on wrapper: data-hidden="true"
 */

(function () {
  'use strict';

  function initGradingFilter() {
    var filterEl = document.getElementById('gp-grade-filters');
    if (!filterEl) return;

    var buttons  = filterEl.querySelectorAll('[data-company]');
    var sectionId = filterEl.getAttribute('data-section');
    var grid      = document.getElementById('gp-products-grid-' + sectionId);
    if (!grid) return;

    var wrappers = grid.querySelectorAll('.gp-product-wrapper[data-grading-company]');

    function filter(company) {
      // Update button states
      buttons.forEach(function (btn) {
        var active = btn.getAttribute('data-company') === company;
        btn.classList.toggle('gp-grade-filter-btn--active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      // Show/hide product wrappers
      wrappers.forEach(function (wrapper) {
        var productCompany = (wrapper.getAttribute('data-grading-company') || '').toUpperCase().trim();
        var shouldShow     = company === 'all' || productCompany === company.toUpperCase();
        if (shouldShow) {
          wrapper.removeAttribute('data-hidden');
        } else {
          wrapper.setAttribute('data-hidden', 'true');
        }
      });
    }

    // Wire up click handlers
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filter(btn.getAttribute('data-company'));
      });
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGradingFilter);
  } else {
    initGradingFilter();
  }

})();
